import React from 'react';
import { Skeleton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { isFalsy } from '../../../utils/common';
import { getSOPDashboardTableColumns } from './utils';
export var dataGridStyles = {
    '& .MuiDataGrid-cell:focus': {
        outline: 'none'
    },
    '& .MuiDataGrid-cell:focus-within': {
        outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus': {
        outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
        outline: 'none'
    },
    '& .MuiDataGrid-columnSeparator': {
        display: 'none'
    },
    '& .MuiDataGrid-columnHeader--filledGroup .MuiDataGrid-columnHeaderTitleContainer': {
        border: '0px'
    },
    '& .MuiDataGrid-columnHeaders': {
        borderBottom: '0px'
    }
};
var SOPDashboardTable = function (_a) {
    var isDataLoading = _a.isDataLoading, dashboardData = _a.dashboardData, _b = _a.source, source = _b === void 0 ? 'CSP' : _b;
    return (React.createElement(DataGrid, { columns: getSOPDashboardTableColumns(source), autoHeight: !isDataLoading, getRowHeight: function () { return 'auto'; }, hideFooter: true, disableColumnFilter: true, disableColumnMenu: true, disableColumnSelector: true, hideFooterPagination: true, hideFooterSelectedRowCount: true, disableDensitySelector: true, disableRowSelectionOnClick: true, showColumnVerticalBorder: true, sx: dataGridStyles, components: {
            NoRowsOverlay: function () { return null; },
            LoadingOverlay: function () { return (React.createElement("div", null, new Array(10).fill(0).map(function (_value, index) { return (React.createElement(Skeleton, { key: index, variant: "rectangular", sx: {
                    mb: '1rem',
                    height: '36px',
                    backgroundColor: '#ebebeb'
                } })); }))); }
        }, loading: isDataLoading, style: {
            background: 'white',
            border: '1px solid #E8E8E8',
            height: isDataLoading ? '700px' : 'auto'
        }, rows: isDataLoading || isFalsy(dashboardData) ? [] : dashboardData, getRowId: function (row) { return row === null || row === void 0 ? void 0 : row.id; } }));
};
export default SOPDashboardTable;
//# sourceMappingURL=SOPDashboardTable.js.map